



























import { Component, Prop, Vue } from "vue-property-decorator";
import { UserAgentHelper } from "@/helper/userAgentHelper"
import { newsApi } from "@/api";
import { News } from "@/data/news/news";

import NewsView from "./newsView/newsView.vue"
import VSpinner from "@/components/VSpinner.vue";

@Component({
    components: {
        VSpinner,
        NewsView
    }
})
export default class NewsAll extends Vue {
    newsList: News[] = [];
    isLoadAllVisible = true;
    isLoadNewVisible = false;

    get browser(){
        return UserAgentHelper.getBrowser()
    }

    mounted(){
        this.loadNews();
    }

    loadNew(hasNext : boolean){
        if (!hasNext) return;
        this.loadNews();
    }

    /**
     * 全てのニュースを用意する
     */
    loadNews() {
        newsApi
            .paginate(this.newsList.length)
            .then(({ news, hasNext }) => {
                this.newsList.push(...news);
                this.isLoadAllVisible = false;
                this.isLoadNewVisible = hasNext;
            })
            .catch(() => {
                // エラーが出たら無限スクロールを諦める
                this.isLoadAllVisible = false;
                this.isLoadNewVisible = false;
            });
    }
}
